"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
const getConfig = (defaultConfig, config) => (0, _deepmerge.default)(defaultConfig, config);
exports.getConfig = getConfig;
var _default = exports.default = getConfig;